var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creation_main"},[_vm._v(" 作品管理 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }